import styled from "styled-components";
import Button from "@mui/material/Button";
import { defaultValueGet } from "common/parameters_common";
import InputField from "components/UI/InputField";

type HtmlTextFormProps = {
  control: any;
  handleSubmit: Function;
  onSubmit: Function;
  reset: Function;
  defaultValues?: any;
};

const HtmlTextForm = ({
  onSubmit,
  handleSubmit,
  reset,
  defaultValues,
  control,
}: HtmlTextFormProps) => {
  const slugDefault = defaultValueGet(defaultValues, "slug", "");
  const contentDefault = defaultValueGet(defaultValues, "content", "");

  return (
    <DivForm>
      <form>
        <DivField>
          <InputField
            name="slug"
            control={control}
            label="slug"
            defaultValue={slugDefault}
          />
        </DivField>
        <DivField>
          <InputField
            name="content"
            control={control}
            label="content"
            defaultValue={contentDefault}
          />
        </DivField>

        <DivNav>
          <Button onClick={handleSubmit(onSubmit)} type="submit">
            Submit
          </Button>
          <Button onClick={() => reset()} variant={"outlined"}>
            Reset
          </Button>
        </DivNav>
      </form>
    </DivForm>
  );
};

const DivForm = styled.div`
  margin-top: 0.75rem;
`;

const DivField = styled.div`
  margin-top: 1rem;
`;

const DivNav = styled.div`
  margin-top: 2rem;
`;

export default HtmlTextForm;
